module.exports = __webpack_public_path__ + "static/media/SaoPaulo_kmeans_202_150.20a8b66d.csv";